import { useEerieBackdrop } from "@/lib/eerie";
import { MatchKeyHost } from "@/components/MatchKey/MatchKeyShell";
import { CHECKERS_CFG } from "@/components/MatchKey/cfgs";

export default function CheckersHostPage() {
  useEerieBackdrop("estampie");
  return <MatchKeyHost cfg={CHECKERS_CFG} />;
}
